<template>
  <div class="section-parameter" v-if="infos">
    <div class="col-left">
      <h2>{{ $t('settings.authentication.title') }}</h2>
    </div>
    <div class="col-right">
      <div class="form-group" >
        <div class="form-group">
          <el-checkbox v-model="localEnable">Local</el-checkbox>
        </div>
        <div class="form-group">
          <label>Signin url</label>
          <el-input v-model="localSignin" :disabled="!localEnable"></el-input>
        </div>
        <div class="form-group">
          <label>Registration url</label>
          <el-input v-model="localRegister" :disabled="!localEnable"></el-input>
        </div>
        <div class="form-submit">
          <el-button plain @click="save">{{ $t('settings.actions.save') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Avatar from 'vue-avatar'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    Avatar
  },
  data () {
    return {
      infos: []
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    }),
    localEnable: {
      get: function () {
        let response = false
        if (this.infos.length > 0) {
          this.infos.forEach((info) => {
            if (info.name === 'Local') {
              if (info.activated === 1) {
                response = true
              }
            }
          })
        }
        return response
      },
      set: function (newValue) {
        if (this.infos.length > 0) {
          this.infos.forEach((info) => {
            if (info.name === 'Local') {
              if (newValue) {
                info.activated = 1
              } else {
                info.activated = 0
              }
            }
          })
        }
      }
    },
    localSignin: {
      get: function () {
        let response = null
        if (this.infos.length > 0) {
          this.infos.forEach((info) => {
            if (info.name === 'Local') {
              response = info.signinurl
            }
          })
        }
        return response
      },
      set: function (newValue) {
        if (this.infos.length > 0) {
          this.infos.forEach((info) => {
            if (info.name === 'Local') {
              info.signinurl = newValue
            }
          })
        }
      }
    },
    localRegister: {
      get: function () {
        let response = null
        if (this.infos.length > 0) {
          this.infos.forEach((info) => {
            if (info.name === 'Local') {
              response = info.registrationurl
            }
          })
        }
        return response
      },
      set: function (newValue) {
        if (this.infos.length > 0) {
          this.infos.forEach((info) => {
            if (info.name === 'Local') {
              info.registrationurl = newValue
            }
          })
        }
      }
    }
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('account', ['updateSite']),

    init () {
      if (this.site) {
        this.site.authentications.forEach((authentication) => {
          this.infos.push(Object.assign({}, authentication))
        })
      }
    },
    save () {
      let site = {}
      site.id = this.site.id
      site.authentications = this.infos

      this.updateSite(site).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.settings.edited'), type: 'success'})
      }).catch((e) => {
        this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/settings/settings_authentification.vue